import React from 'react';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as cts from '../../../constants/ui/svg';
import { Switch, Input, Modal } from 'antd';
import beside from '../../../assets/images/beside.png';
import slide from '../../../assets/images/slide.png';
import { useAppSelector } from '../../../hooks';

type Props = {
  selectedLayoutRanking: number;
  setSelectedLayoutRanking: React.Dispatch<React.SetStateAction<number>>;
};

export default function Layout({ setSelectedLayoutRanking, selectedLayoutRanking }: Props) {
  const { t } = useTranslation();
  const shopSettings = useAppSelector((state) => state.shopSetting.shopSetting);
  useEffect(() => {
    setSelectedLayoutRanking(Number(shopSettings?.data?.layout_ranking));
  }, [shopSettings?.data?.layout_ranking]);
  return (
    <div className="flex flex-col pt-[12px] px-[16px]">
      <span className="text-[#252B37] text-[20px] notosans_bold">{t('LAYOUT')}</span>
      <div className="flex items-center mt-[16px]">
        <button
          onClick={() => {
            setSelectedLayoutRanking(0);
            localStorage.setItem('layout', '0');
          }}
          className={`${
            selectedLayoutRanking === 0
              ? 'bg-[#F9F5FF] border border-solid border-[#666687]'
              : 'border border-solid border-[#D5D7DA]'
          } flex flex-col items-center justify-center rounded-[8px] p-[12px] w-fit`}
        >
          <img src={beside} className="w-[240px] h-[154px] " />
          <div className="flex items-center">
            <span>{selectedLayoutRanking === 0 ? cts.checkActive : cts.check}</span>
            <span className="text-[14px] text-[#252B37] notosans_normal ml-[8px]">
              {t('BESIDE')}
            </span>
          </div>
        </button>
        <button
          onClick={() => {
            setSelectedLayoutRanking(1);
            localStorage.setItem('layout', '1');
          }}
          className={`${
            selectedLayoutRanking === 1
              ? 'bg-[#F9F5FF] border border-solid border-[#666687]'
              : 'border border-solid border-[#D5D7DA]'
          } flex flex-col items-center justify-center rounded-[8px] p-[12px] w-fit ml-[12px]`}
        >
          <img src={slide} className="w-[240px] h-[154px] " />
          <div className="flex items-center">
            <span>{selectedLayoutRanking === 1 ? cts.checkActive : cts.check}</span>
            <span className="text-[14px] text-[#252B37] notosans_normal ml-[8px]">
              {t('SLIDER')}
            </span>
          </div>
        </button>
      </div>
    </div>
  );
}
